export default __webpack_public_path__ + "f6ece99777c3f6f861b04cdc1cd9a92f.png";